<template>
	<div class="container mx-auto max-w-5xl px-4">
		<div class="flex flex-col justify-between">
			<div class="flex p-2">
				<HelpfulTips>
					Please enter your ride's mileage. We would prefer to know the exact mileage on
					the odometer, but if you are not near your car, please enter the approximate
					mileage that you can remember.
				</HelpfulTips>

				<div class="grow basis-1/2">
					<form class="flex flex-col" action="#">
						<AppInput
							v-model="form.mileage"
							v-maska="['###,###', '##,###', '#,###', '###', '##', '#']"
							type="text"
							name="mileage"
							placeholder="Mileage"
							pattern="\d*"
							inputmode="numeric"
							autocomplete="off"
							aria-autocomplete="none"
							@submit="onSubmitMileage"
						>
							<template #prepend>
								<RoadSvg />
							</template>
						</AppInput>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { useFormStore } from '../../../stores/form'
	import AppInput from '../../common/AppInput.vue'
	import RoadSvg from '../components/icons/RoadSvg.vue'
	import HelpfulTips from '../components/HelpfulTips.vue'
	import { EVENT_BUS_EVENTS, useEventBus } from '../../../stores/eventBus'

	// hooks
	const form = useFormStore()
	const eventBus = useEventBus()

	// methods
	const onSubmitMileage = () => {
		eventBus.emit({ name: EVENT_BUS_EVENTS.FORM_NEXT_STEP })
	}
</script>
